import { getFeatures } from 'pricing-pages-lib/api/FeaturesApi';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { FEATURES, FEATURES_CMS, FEATURES_MARKETING, FEATURES_OPERATIONS, FEATURES_SALES, FEATURES_SERVICE } from './constants/RequestedDataTypes';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const FetchFeaturesRequestTypes = createRequestTypes(FEATURES); // PER PRODUCT LINE REQUESTS

export const FetchFeaturesRequestTypesMARKETING = createRequestTypes(FEATURES_MARKETING);
export const FetchFeaturesRequestTypesSALES = createRequestTypes(FEATURES_SALES);
export const FetchFeaturesRequestTypesSERVICE = createRequestTypes(FEATURES_SERVICE);
export const FetchFeaturesRequestTypesOPERATIONS = createRequestTypes(FEATURES_OPERATIONS);
export const FetchFeaturesRequestTypesCMS = createRequestTypes(FEATURES_CMS);
export const FetchFeatureActions = createRequestActions(FetchFeaturesRequestTypes); // PER PRODUCT LINE ACTIONS

export const FetchFeatureActionsMARKETING = createRequestActions(FetchFeaturesRequestTypesMARKETING);
export const FetchFeatureActionsSALES = createRequestActions(FetchFeaturesRequestTypesSALES);
export const FetchFeatureActionsSERVICE = createRequestActions(FetchFeaturesRequestTypesSERVICE);
export const FetchFeatureActionsOPERATIONS = createRequestActions(FetchFeaturesRequestTypesOPERATIONS);
export const FetchFeatureActionsCMS = createRequestActions(FetchFeaturesRequestTypesCMS);
export const fetchFeatures = ({
  highlightedProducts,
  productLine
}) => {
  let requestActions = FetchFeatureActions;

  switch (productLine) {
    case MARKETING:
      requestActions = FetchFeatureActionsMARKETING;
      break;

    case SALES:
      requestActions = FetchFeatureActionsSALES;
      break;

    case SERVICE:
      requestActions = FetchFeatureActionsSERVICE;
      break;

    case OPERATIONS:
      requestActions = FetchFeatureActionsOPERATIONS;
      break;

    case CMS:
      requestActions = FetchFeatureActionsCMS;
      break;

    default:
      requestActions = FetchFeatureActions;
      break;
  }

  return makeFetchRequest({
    requestActions,
    fetch: getFeatures,
    payload: {
      highlightedProducts,
      productLine
    }
  });
};